<!--
  帮助反馈
  jay 2020-01-14
-->
<template>
  <div class="w100">
    <van-nav-bar
      :title="$t('personal.giveFeedback')"
      :fixed="true"
      left-arrow
      @click-left="_back"
    />
    <div class="scroll-wrapper help-wrapper">
      <div class="help-title">
        <h3>{{ $t("personal.commonProblem") }}</h3>
        <a class="text-orange" @click="randomArr">
          {{ $t("personal.helpChange") }}
        </a>
      </div>
      <div class="help-content">
        <scroll class="help-scroll">
          <van-collapse v-model="activeNames" accordion>
            <van-collapse-item
              :title="item.question"
              :name="index"
              v-for="(item, index) in helpList"
              :key="index"
            >
              {{ item.answer }}
            </van-collapse-item>
          </van-collapse>
        </scroll>
      </div>
      <div class="feedback">
        <h3>{{ $t("personal.suggestionsOpinions") }}</h3>
        <van-field
          class="feedback-textarea"
          v-model="feedback"
          :rows="5"
          type="textarea"
          maxlength="100"
          :placeholder="$t('personal.enterSuggestionsOpinions')"
          show-word-limit
        />
      </div>
      <div class="button-wrap">
        <van-button
          block
          type="primary"
          :loading="btnLoading"
          @click="submitFun"
        >
          {{ $t("common.submit") }}
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "help",
  meta: {
    service: false // 客服
  },
  components: {},
  data() {
    return {
      activeNames: 0,
      feedback: "",
      helpList: [],
      allList: [],
      btnLoading: false
    };
  },
  created() {
    this._getQuestion();
  },
  mounted() {},
  computed: {},
  methods: {
    _getQuestion() {
      //获取常见问题
      let vm = this;
      vm.$post("/app/user/question", {}, { loading: true }).then(res => {
        console.log("question", res);
        vm.allList = res;
        console.log("allList", vm.allList);
        vm.randomArr();
      });
    },
    randomArr() {
      let vm = this;
      let arr = [];
      while (arr.length < 5) {
        var temp = Math.floor(Math.random() * vm.allList.length);
        // var temp = (Math.random() * vm.allList.length) >> 0;
        let flag = true;
        for (let key of arr) {
          if (vm.allList[temp].id == key.id) {
            flag = false;
            break;
          }
        }
        if (flag) {
          arr.push(vm.allList[temp]);
        }
      }
      vm.helpList = arr;
    },
    submitFun() {
      //反馈意见
      let vm = this;
      if (vm.feedback == "") {
        vm.$toast(vm.$t("personal.enterSuggestionsOpinions"));
        return;
      }
      let params = {};
      params.content = vm.feedback;
      vm.btnLoading = true;
      vm.$post("/app/user/feedback", params, { alert: true }).then(res => {
        console.log("feedback", res);
        vm.btnLoading = false;
        if (res.code == 0) {
          vm.feedback = "";
        }
        vm.$toast(res.msg);
      });
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
.help-wrapper {
  .help-title {
    padding: 0 16px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    h3 {
      font-size: 16px;
      color: #4a4a4a;
      font-weight: 500;
    }
  }

  .help-content {
    padding: 0 16px;
    // height: calc(100vh - 44px - 50px - 50px - 160px - 85px);
    height: calc(100% - 50px - 50px - 160px - 85px);
    position: relative;

    .help-scroll {
      top: 0 !important;
    }

    /deep/.van-cell__title {
      color: #2042ab;
    }
  }

  .feedback {
    border-top: 1.1px solid #e4e4e4;
    padding: 0 16px;

    h3 {
      height: 50px;
      display: flex;
      align-items: center;
      font-size: 16px;
      color: #4a4a4a;
      font-weight: 500;
    }

    .feedback-textarea {
      width: 100%;
      height: 160px;
      border-radius: 5px;
      border: 1.1px solid #e4e4e4;

      /deep/.van-field__body {
        height: calc(100% - 20px);
      }

      .van-field__control {
        height: 100%;
      }
    }
  }
}
</style>
